//index-search.js
//JavaScript for search on index page

//Vue
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import ToastService from 'primevue/toastservice';

const PrimeVuePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{orange-50}',
            100: '{orange-100}',
            200: '{orange-200}',
            300: '{orange-300}',
            400: '{orange-400}',
            500: '{orange-500}',
            600: '{orange-600}',
            700: '{orange-700}',
            800: '{orange-800}',
            900: '{orange-900}',
            950: '{orange-950}',
        }
    }
});

import TranscriptSuggestion from './components/TranscriptSuggestion.vue';
import SoundPlayer from './components/SoundPlayer.vue';
import Search from './components/Search.vue';
import SoundDownloader from './components/SoundDownloader.vue';

import tooltipDirective from './directives/tooltip.js';
    
import axios from 'axios';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//Lazy loading component
import LazyComponent from 'v-lazy-component';

//Alerts library
import Swal from 'sweetalert2';

//Override search form to use RESTful search instead of querystring
document.addEventListener('DOMContentLoaded', function() {
    const searchForm = document.getElementById('searchForm');
    if (searchForm) {
        searchForm.onsubmit = function(event) {
            event.preventDefault();
            const searchText = document.getElementById('searchInput').value;
            window.location.href = `/search-static/${encodeURIComponent(searchText)}`;
        };
    }
});

window.vueApp = createApp({
    data: function () {
        return {
            searchText: '',
            currentRequests: [], //XHR requests to enable aborting
            selectedSound: false, //Currently selected sound, used to populate options modal
            volume: 100,
            hCaptchaLoaded: false, //We are dynamically loading HCaptcha scripts, as they are rarely used
            showDropTarget: false,
            sound_requestedToDownload: false, //Store the last requested sound to download, to aid in CAPTCHA presentation
            selectedSound: false, //Currently selected sound, used to populate options modal
            hCaptchaLoaded: false, //We are dynamically loading HCaptcha scripts, as they are rarely userID
            contextMenuEnableDownload: true,
            contextMenuEnableMoreOptions: true,
            trendingSounds: false,
            country_name: false,
            country_code: false,
            favorites: [], //User or session's favorite sounds (array of IDs)
            isMobile: false, //Is this a mobile browser
            isLowBandwidth: null, //Is the connection low bandwidth. Not all browsers can be detected, so defaults to null
            preloadSoundsLimit: null, //Limit number of sounds to preload
        }
    },
    methods: {
        //Automatically scroll to have results and search bar in view
        autoscrollToSearchAndSelect: function () {
            var element = document.getElementById('ads_top_anchor');
            var headerOffset = 60;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            //Focus on the search input element
            // document.getElementById("searchInput").focus();
            //Select the text for easy overtyping
            element.select()
            // element.selectionStart = element.selectionEnd = element.value.length;
        },
        show_soundModal: function (sound) {
            //Share individual sound with a popup modal containing dynamic AddToAny
            console.log('show_soundModal handled');
            console.log(sound);

            //Set data to populate modal with
            this.selectedSound = sound;

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + sound.link;
            console.log('sound link: ' + sound_link);

            //If HTML5 Web Share API is available and this is a mobile browser
            if (navigator.share && window.mobileCheck()) {
                console.log('HTML5 Web Share API available and this is a mobile browser');
                var a2a_content = `<button class="btn btn-large btn-warning shareBtn" id="soundShareBtn">
                    <i class="fas fa-fw fa-share-alt" aria-hidden="true"></i><br />Share</button>`;
                const shareButtonsContainer = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtonsContainer) {
                    shareButtonsContainer.innerHTML = a2a_content;
                }
                const soundShareBtn = document.getElementById('soundShareBtn');
                if (soundShareBtn) {
                    soundShareBtn.addEventListener('click', () => {
                        console.log('soundShareBtn pressed');
                        //If Web Share API is available, and is mobile browser
                        if (navigator.share && window.mobileCheck()) {
                            navigator.share({
                                title: sound.sound_transcript,
                                url: sound_link
                            }).then(() => {
                                console.log('Shared via HTML5 Web Share API');
                            })
                                .catch(console.error);
                        } else {
                            //Otherwise classic share by opening modal
                            const shareBoardModal = new bootstrap.Modal(document.getElementById('shareBoardModal'));
                            shareBoardModal.show();
                        }
                    });
                }
            } else {
                //Otherwise use Add2Any
                //Set the content of the modal to contain share buttons with a dynamic link
                var a2a_content = `
            <div class="a2a_kit a2a_kit_size_32 a2a_default_style" data-a2a-url="` + escape(sound_link) + `" data-a2a-title="` + escape(sound.sound_transcript) + `">
            <a class="a2a_button_facebook"></a>
            <a class="a2a_button_twitter"></a>
            <a class="a2a_button_email"></a>
            <a class="a2a_button_google_gmail"></a>
            <a class="a2a_button_reddit"></a>
            <a class="a2a_button_whatsapp"></a>
            <a class="a2a_button_pinterest"></a>
            <a class="a2a_button_telegram"></a>
            <a class="a2a_button_skype"></a>
            <a class="a2a_button_copy_link"></a>
            <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
            </div>`
                const shareButtons = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtons) {
                    shareButtons.innerHTML = a2a_content;
                }
            }

            //Set link destination for 'Go to sound' button
            const goToSoundBtn = document.querySelector("#soundModal #share-go-to-sound");
            if (goToSoundBtn) {
                goToSoundBtn.setAttribute('href', sound_link);
            }

            //Set link destination for 'Go to board' button
            const goToBoardBtn = document.querySelector("#soundModal #share-go-to-board");
            if (goToBoardBtn) {
                goToBoardBtn.setAttribute('href', '/boards/' + sound.board_id);
            }

            //Set value of URL field ready for copy and pasting
            const shareLink = document.querySelector("#soundModal #share-link");
            if (shareLink) {
                shareLink.value = sound_link;
            }

            //Click to copy behaviors
            const copyLinkElements = document.querySelectorAll("#soundModal #share-copy-link, #soundModal #share-link");
            copyLinkElements.forEach(el => {
                el.addEventListener('click', function () {
                    //Get the text field
                    var copyText = document.getElementById("share-link");
                    //Select the text field
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); //For mobile devices
                    //Copy the text inside the text field
                    document.execCommand("copy");
                    //Indicate copy success
                    const shareCopyLink = document.querySelector("#soundModal #share-copy-link");
                    if (shareCopyLink) {
                        shareCopyLink.innerHTML = '<i class="fas fa-fw fa-check"></i><br>Copy Link<br>';
                    }

                //Toast
                window.$toast.add({
                    severity: 'success',
                    summary: 'Link copied',
                    detail: 'The link has been copied to your clipboard.',
                    life: 2000,
                });
                });
            });

            //Reset copy indicator
            const resetCopyLink = document.querySelector("#soundModal #share-copy-link");
            if (resetCopyLink) {
                resetCopyLink.innerHTML = '<i class="fas fa-fw fa-copy"></i><br />Copy Link<br />';
            }

            //Show modal
            const soundModal = new bootstrap.Modal(document.getElementById('soundModal'));
            soundModal.show();

            //Close tooltips
            console.log('Close all tooltips');
            const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltips.forEach(el => {
                if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                    const tooltip = bootstrap.Tooltip.getInstance(el);
                    if (tooltip) {
                        tooltip.hide();
                    }
                }
            });
        },
        webShare: function (sound) {
            if (navigator.share) {
                navigator.share({
                    title: 'Sound clip: \'' + sound.sound_transcript + '\'',
                    url: 'https://' + window.location.hostname + sound.link
                }).then(() => {
                    console.log('Shared.');
                })
                    .catch(console.error);
            } else {
                console.log('Web Share API not available for sound ' + sound)
            }
        },
        //Show error message
        showErrorMessage: function (message) {
            console.log('Show error message', message);
            Swal.fire({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 5000,
                timerProgressBar: true,
                theme: 'auto'
            });
        },
        //Show a context menu with options for sound
        show_contextMenu: function (sound, showContextMenuOptions = true) {
            console.log('show_contextMenu');
            console.log(sound);

            this.contextMenuEnableDownload = showContextMenuOptions;
            this.contextMenuEnableMoreOptions = showContextMenuOptions;
            this.contextMenuEnableDownload = true;

            //Set data to populate context menu with
            this.selectedSound = sound;

            //Display menu off canvas to be able to measure dimensions
            const contextMenu = document.getElementById("context-menu");
            if (contextMenu) {
                contextMenu.style.display = "block";
                contextMenu.style.position = "fixed";
                contextMenu.style.left = "-10000px";
                contextMenu.style.top = "-10000px";
                contextMenu.classList.add("show");
            }

            //Default position for context menu will be cursor position
            var left = event.clientX;
            var top = event.clientY;

            //Viewport width and height
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

            //If click is too close to the right, open the menu without clipping the edge
            if ((event.clientX + document.querySelector('#context-menu').offsetWidth + 25) > vw) {
                left = vw - (document.querySelector('#context-menu').offsetWidth + 25);
            }

            //If click is too close to the bottom, open the menu without clipping the bottom
            if (event.clientY > vh - document.querySelector('#context-menu').offsetHeight + 25) {
                top = event.clientY - document.querySelector('#context-menu').offsetHeight;
            }

            console.log(left, top);

            //Display menu
            if (contextMenu) {
                contextMenu.style.display = "block";
                contextMenu.style.position = "fixed";
                contextMenu.style.left = left + "px";
                contextMenu.style.top = top + "px";
                contextMenu.classList.add("show");
            }

            //Hide menu on option click
            const hideMenu = () => {
                const menu = document.getElementById("context-menu");
                if (menu) {
                    menu.classList.remove("show");
                    menu.style.display = "none";
                }
            };
            if (contextMenu) {
                contextMenu.querySelectorAll("a, button").forEach(el => el.addEventListener("click", hideMenu));
            }
            document.body.addEventListener("click", hideMenu);

        },
        openNewWindow: function (path) {
            console.log('openNewWindow');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            window.open(sound_link);
        },
        copyToClipboard: function (path) {
            console.log('copyToClipboard');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = sound_link;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
            } catch (err) {
                console.log('Oops, unable to copy');
            }

            document.body.removeChild(textArea);
        },
        tweet: function (path) {
            window.open('https://www.twitter.com/intent/tweet?url=' + encodeURIComponent('https://www.101soundboards.com' + path), '_blank');
        },
        triggerDownloadSound: function (sound) {
            console.log('triggerDownloadSound (index)', sound);
            this.download(sound);
        },
        download: function (sound) {
            console.log('triggerDownloadSound (index)');
            console.log(sound);
            //Use SoundDownloader component to download sound
            if (this.$refs.soundDownloader) {
				this.$refs.soundDownloader.download(sound);
			} else {
				console.error('SoundPlayer: No soundDownloader ref');
			}
        },
        triggerEmbedSound: function (sound, event) {
            console.log('triggerEmbedSound (sound)');
            console.log(sound, event);
            const embed_string = '<iframe width="300" height="215" scrolling="no" frameborder="none" src="https://www.101soundboards.com' + sound.link + '/video/player_embed' + '" type="video/mp4"></iframe><br /><a href="' + 'https://www.101soundboards.com' + sound.link + '">' + sound.sound_transcript + '</a>';
            console.log(embed_string);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = embed_string;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
                if (document.getElementById('embed_button')) {
                    document.getElementById('embed_button').innerHTML = 'Copied to Clipboard';
                }
            } catch (err) {
                console.log('Oops, unable to copy');
                if (document.getElementById('embed_button')) {
                    document.getElementById('embed_button').innerHTML = 'Unable to Copy To Clipboard';
                }
            }
            document.body.removeChild(textArea);
        },
        triggerPlaySound: function (sound) {
            console.log('playSound (board)');
            console.log(sound);
            //Call the play method on the individual sound
            console.log(this.$refs);
            this.$refs['soundPlayer_' + sound.id][0].play();
        },
        //Load a JavaScript file programatically and return a promise when loaded/error
        loadScript: function (script_url) {
            console.log('Load script ' + script_url)
            return new Promise((resolve, reject) => {
                let script_element = document.createElement('script');
                script_element.onload = function () {
                    console.log('Script ' + script_url + ' loaded')
                    resolve(true)
                };
                script_element.onerror = function (error) {
                    console.error('Script ' + script_url + ' loading error', error)
                    reject('Error loading script')
                }
                script_element.src = script_url;
                document.head.appendChild(script_element);
            })
        },
        addToFavorites: function (sound) {
            //Add to favorites
            console.log('addToFavorites', sound);
            console.log(sound);

            //Check if already in favorites
            if (this.favorites.some(favorite => favorite === sound.id)) {
                //Already in favorites, delete
                console.log('Already in favorites. Removing...');

                //Remove from favorites for instant user feedback
                _.remove(this.favorites, (favorite) => favorite === sound.id);

                axios.delete(`/api/v1/favorites/${sound.id}`)
                    .then((response) => {
                        console.log(response);

                        window.$toast.add({
                            severity: 'success',
                            summary: 'Removed from favorites',
                            html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                            life: 10000
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log('Showing error toast...')
                        Swal.fire({
                            title: 'Problem',
                            text: 'There was a problem with your favorites. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            theme: 'auto'
                        });

                        //Add back to favorites
                        this.favorites.push(sound.id);
                    });

                return true;
            }

            //Otherwise, continue adding
            console.log('Adding to favorites...');

            //Add to end of favorites for instant user feedback
            this.favorites.push(sound.id);

            axios.put(`/api/v1/favorites/${sound.id}`)
                .then((response) => {
                    console.log(response);
                    console.log('Showing toast...')

                    window.$toast.add({
                        severity: 'success',
                        summary: 'Added to favorites',
                        html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                        life: 10000
                    });
                })
                .catch((error) => {
                    console.log(error);
                    console.log('Showing error toast...')
                    Swal.fire({
                        title: 'Problem',
                        text: 'There was a problem with your favorites. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });

                    //Remove from favorites
                    _.remove(this.favorites, (favorite) => favorite === sound.id);
                });
        },
        loadFavorites: function () {
            console.log('loadFavorites');
            //Load with axios
            axios.get('/api/v1/favorites/me')
                .then(response => {
                    console.log(response);
                    this.favorites = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    // this.showErrorMessage(error);
                });
        },
        isFavorite: function (sound) {
            //Check if sound is in favorites
            return this.favorites.some(favorite => favorite === sound.id);
        },
        report: function (sound) {
            //Report sound
            console.log('report', sound);
            console.log(sound);

            Swal.fire({
                title: 'Report Sound',
                html: 'Are you sure you want to report this sound?<br><br>You should only report sounds with offensive content, personal details, or if this was a Text-to-Speech phrase you created and would like to be removed.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Report',
                cancelButtonText: 'Cancel',
                theme: 'auto'
            }).then((result) => {
                if (!result.isConfirmed) {
                    return false;
                }

                axios.put(`/api/v1/sounds/${sound.id}/reports`)
                    .then(function (response) {
                        console.log(response);
                        console.log('Showing alert...')

                        Swal.fire({
                            title: 'Sound Reported',
                            text: 'Sound reported. Our moderators will review it shortly. If you reported a TTS phrase you created, it will be removed momentarily.',
                            icon: 'success',
                            buttons: {
                                OK: true
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        })
                    })
                    .catch(function (error) {
                        console.error(error);
                        console.log('Showing error alert...')
                        Swal.fire({
                            title: 'Error',
                            text: 'There was a problem reporting this sound. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        });
                    });
            });
        },
        showTrending: function () {
            console.log('showTrending');

            //Get country code
            axios.get('/api/v1/country')
                .then((response) => {
                    console.log('/api/v1/country', response.data);

                    this.country_name = response.data.country_name;
                    this.country_code = response.data.country_code;

                    //Could not retrieve country_name
                    if (!this.country_name) {
                        console.log('Could not retrieve country name');
                        this.error = true;
                        return;
                    }

                    console.log('country_name', this.country_name);
                    this.error = false;

                    //Get trending sounds list for the country
                    axios.get('/api/v1/country/' + this.country_name + '/trending/week')
                        .then((response) => {
                            console.log(response.data);

                            //Set trending sounds
                            this.trendingSounds = response.data;

                            //After 30 minutes, reload trending sounds by calling showTrending again
                            setTimeout(() => {
                                console.log('Reloading trending sounds');
                                this.showTrending();
                            }, 30 * 60 * 1000);
                        })
                        .catch((error) => {
                            console.log(error);
                            this.error = true;
                        });
                })
                .catch((error) => {
                    console.log(error);
                    this.error = true;
                });
        },
        shouldPreload: function (sound) {
            console.log('shouldPreload');

            //No preload for low bandwidth clients
            if (this.isLowBandwidth) {
                return false;
            }
            
            //Find position of sound on board
            const soundPositionOnBoard = this.trendingSounds.findIndex(s => s.id === sound.id);

            //Only preload the first x sounds
            if (soundPositionOnBoard >= this.preloadSoundsLimit) {
                console.log('Preloading sound: No', 'sound position:', soundPositionOnBoard, 'sound id:', sound.id, 'preloadSoundsLimit:', this.preloadSoundsLimit);
                return false;
            }

            //Default to full preload
            console.log('Preloading sound: Yes', 'sound position:', soundPositionOnBoard, 'sound id:', sound.id, 'preloadSoundsLimit:', this.preloadSoundsLimit);
            return true;
        },
    },
    computed: {
        countryFlagImg: function () {
            return '/img/flags/' + this.country_code.toLowerCase() + '.svg';
        },
        soundsCount: function () {
            return (this.trendingSounds.sounds.length);
        },
    },
    mounted: function () {
        console.log('Mounted');
        console.log('Crossroads begin');
        //Add route for handling search
        crossroads.addRoute('/search', (searchText) => {
            //Scroll to search box and focus on text input if empty search route requested
            this.autoscrollToSearchAndSelect();
        });
        crossroads.addRoute('/search/{searchText}', (searchText) => {
            //Perform search, scroll to text input and focus on text input if search defined
            searchText = decodeURIComponent(searchText);
            console.log('search Route', searchText);
            this.searchText = searchText;
        });
        //Log all routes
        crossroads.routed.add(console.log, console);
        //Parse URL on load
        crossroads.parse(document.location.pathname);

        //Listen for volume change events
        window.addEventListener('volumeChange', (event) => {
            console.log('There was a volume change event (board.js)')
            console.log(event)
            console.log(event.volume)
            this.volume = event.volume
        })

        //Check if this is a mobile browser
        if (window.matchMedia("(max-width: 767px)").matches) {
            //The viewport is less than 768 pixels wide
            console.log("This is a mobile device")
            this.isMobile = true
        }

        //Check for low bandwidth device. Not available on all browsers
        if (typeof navigator.connection !== 'undefined' && typeof navigator.connection.downlink !== 'undefined') {
            const downlinkSpeed = navigator.connection.downlink;
            console.log('downlinkSpeed: ', downlinkSpeed);
            if (downlinkSpeed < 7.5) {
                this.isLowBandwidth = true;
            }
            if (downlinkSpeed >= 7.5) {
                this.isLowBandwidth = false;
            }
            console.log('isLowBandwidth: ' + this.isLowBandwidth)
        }

        //Limit number of sounds to preload
        if (this.isMobile) {
            this.preloadSoundsLimit = 10;
        } else {
            this.preloadSoundsLimit = 30; //Default
        }

        //Load trending sounds
        this.showTrending();

        // //Auto reload page every 27 minutes, to keep secure asset links fresh (they expire)
        // const reloadPageAfter = 27 * 60 * 1000;
        // setTimeout( () => {
        //     console.log('Refreshing page after ' + reloadPageAfter + ' delay')
        //     window.location.reload(true);
        // }, reloadPageAfter);

        //Load favorites
        this.loadFavorites();
    }
})
    .component('transcript-suggestion', TranscriptSuggestion)
    .component('sound-player', SoundPlayer)
    .component('search', Search)
    .component('sound-downloader', SoundDownloader)
    .use(LazyComponent)
    .use(PrimeVue, {
        theme: {
            preset: PrimeVuePreset,
            options: {
                prefix: 'p',
                darkModeSelector: 'system',
                cssLayer: false
            }
        },
    })
    .use(ToastService)
    .directive('tooltip', tooltipDirective)
    .mount('#vueApp');

// //Live counter
// import ReconnectingWebSocket from 'reconnecting-websocket';

// var total_duration;
// var total_plays;
// var total_clients_connected;

// document.addEventListener("DOMContentLoaded", function (event) {
//     //Connect to websockets
//     console.log('Opening websocket connection');
//     var ws_url = ((window.location.protocol === "https:") ? "wss://" : "ws://") + window.location.host + '/api/v1/hits/websockets';
//     console.log(ws_url)
//     const ws = new ReconnectingWebSocket(ws_url);

//     ws.onopen = (event) => {
//         console.log("[ws open] Connection established, send -> server");
//         ws.send("hello");

//         //After 2 minutes, close the connection to save resources
//         setTimeout(() => {
//             console.log('Closing websocket connection after 2 minutes')
//             ws.close();
//         }, 2 * 60 * 1000);
//     };

//     //On browser close or move away from page, close websocket
//     window.addEventListener('beforeunload', function (event) {
//         console.log('Closing websocket connection on beforeunload event')
//         ws.close();
//     });

//     ws.onmessage = (event) => {
//         console.log(`[ws message] Data received: ${event.data} <- server`);
//         var data = JSON.parse(event.data)
//         if (data.type === 'stats') {
//             console.log('stats')

//             //Deal with stats update
//             total_duration = data.total_duration
//             total_plays = data.total_plays
//             total_clients_connected = data.total_clients_connected

//             if (document.querySelector('.index_playcount_container')) {
//                 let formattedPlays = total_plays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//                 document.getElementById('index_playcount').textContent = formattedPlays;
//                 document.querySelector('.index_playcount_container').classList.remove('index_playcount_container_hidden');
//             }
//         }
//     };

//     ws.onclose = (event) => {
//         if (event.wasClean) {
//             console.log(`[ws close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
//         } else {
//             // e.g. server process killed or network down
//             // event.code is usually 1006 in this case
//             console.log('[ws close] Connection died');
//         }
//     };

//     //Possible TODO: Reconnect on error. As these statistics is certainly non-critical, then not currently implemented
//     ws.onerror = (error) => {
//         console.log(`[ws error] ${error.message}`);
//     };
// });

//Hits counter
var total_duration;
var total_plays;
var total_clients_connected;

const getHits = () => {
    //Only if index page
    if (window.location.pathname === '/') {

        //Axios request /api/v1/hits/sounds/stats
        axios.get('/api/v1/hits/sounds/stats')
            .then(response => {
                console.log(response);
                total_duration = response.data.total_duration;
                total_plays = response.data.total_plays;
                total_clients_connected = response.data.total_clients_connected;

                //Round total plays to nearest 1000
                total_plays = Math.round(total_plays / 1000) * 1000;
                //Subtract 1000 and add 101 to make it look cool
                total_plays = total_plays - 1000 + 101;

                if (document.querySelector('.index_playcount_container')) {
                    let formattedPlays = total_plays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    document.getElementById('index_playcount').textContent = formattedPlays;
                    document.querySelector('.index_playcount_container').classList.remove('index_playcount_container_hidden');
                }
            })
            .catch(error => {
                console.log(error);
            }
            );
    }
};

// document.addEventListener("DOMContentLoaded", function (event) {
//     getHits();

//     //Get hits every 30 seconds
//     setInterval(getHits, 30 * 1000);
// });

//Click tagline and hear a sound. Only add when page is fully loaded. Uses Web Audio API as experiment
window.addEventListener('load', (event) => {
    console.log('Page is fully loaded');
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    let audioBuffer;

    //Preload audio
    const preloadAudio = () => {
        if (!audioBuffer) {
            console.log('Preloading audio');
            axios.get('/audio/meep.mp3', { responseType: 'arraybuffer' })
                .then(response => {
                    audioContext.decodeAudioData(response.data, function (buffer) {
                        audioBuffer = buffer;
                        console.log('Audio preloaded');
                    }, function (e) {
                        console.error('Error with decoding audio data', e);
                    });
                })
                .catch(error => {
                    console.error('Error fetching audio file', error);
                });
        }
    };

    //Preload audio on mouseover
    const site_tagline = document.getElementById('site_tagline');

    if (site_tagline) {
        site_tagline.addEventListener('mouseover', preloadAudio);

        //Play audio on click
        site_tagline.addEventListener('click', function () {
            console.log('Tagline click, playing audio');
            if (audioBuffer) {
                const source = audioContext.createBufferSource();
                source.buffer = audioBuffer;
                source.connect(audioContext.destination);
                source.start(0);
            } else {
                console.error('Audio not preloaded. Cannot play.');
            }
        });
    }
});